<template>
	<div class="container-box">
		<div :id="id" :style="{height:height,width:width}"></div>
	</div>
</template>

<script>
	import echarts from 'echarts';
	export default {
		props: ['className', 'id', 'height', 'width', 'title','labelData'],
		data() {
			return {}
		},
		mounted() {
			let data=this.labelData.map(item=>{
				return item.value;
			})
			let max = data.reduce(function(a , b){
			return b > a ? b : a;
			});
			let dataMax=this.labelData.map(item=>{
				return {
					name: item.name,
					max: max
				}
			})
			this.initData(data,dataMax);
		},
		beforeDestroy() {

		},
		methods: {

			initData(data,dataMax) {
				// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(document.getElementById(this.id))
				// 绘制图表
				myChart.setOption({
					tooltip: {},
					radar: {
						name: {
							textStyle: {
								color: 'rgba(4, 195, 241, 1)',
							}
						},
						splitLine: {
							lineStyle: {
								color: [
									'rgba(4, 195, 241, 0.1)', 'rgba(4, 195, 241, 0.2)',
									'rgba(4, 195, 241, 0.4)', 'rgba(4, 195, 241, 0.6)',
									'rgba(4, 195, 241, 0.8)', 'rgba(4, 195, 241, 1)'
								].reverse()
							}
						},
						splitArea: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: 'rgba(4, 195, 241, 0.5)'
							}
						},
						indicator: dataMax,
						shape:'circle',
						splitNumber:5,
					},
					series: [{
						name: '',
						type: 'radar',
						lineStyle: {
							normal: {
								width: 1,
								opacity: 0.5
							}
						},
						data: [{
								value: data,
								name: ''
							}
						],
						symbol: 'none',
						itemStyle: {
							color: '#04C3F1'
						},
						areaStyle: {
							opacity: 0.1
						}
					}]
				})
			},

		}
	}
</script>

<style lang="less" scoped>
</style>
